import api from './api';

// Admin > Billing > OHIP Environments — the list the daily OHIP Transactions scrape reports on.
//
// `groupKey` is accepted on create and rejected on update: it is the key every indexed billing document
// and every raw S3 report is stored under, so changing it would detach a group from its own history. The
// lambda enforces that too; the service simply never offers it.
const ohipHotelGroupsService = {
    list: (params) => api.get('/admin/ohip-hotel-groups', { params }),
    // The hotel_code -> environment map, plus the same data grouped by environment. Served by the
    // hotel-groups lambda because it is the one with a database connection; both Billing screens use it.
    environments: () => api.get('/admin/ohip-hotel-groups', { params: { view: 'environments' } }),
    get: (id) => api.get(`/admin/ohip-hotel-groups/${id}`),
    create: (data) => api.post('/admin/ohip-hotel-groups', data),
    update: (id, data) => api.put(`/admin/ohip-hotel-groups/${id}`, data),
    remove: (id) => api.delete(`/admin/ohip-hotel-groups/${id}`),
    // Link hotels wizard (OHIP Transactions > Link hotels). Same route, query-param view / body action.
    hotelLinks: () => api.get('/admin/ohip-hotel-groups', { params: { view: 'hotel-links' } }),
    saveHotelLinks: (links) => api.post('/admin/ohip-hotel-groups', { action: 'link-hotels', links }),
    attributeGroups: (groups) => api.post('/admin/ohip-hotel-groups', { action: 'attribute-groups', groups }),
};

export default ohipHotelGroupsService;
